import { render, staticRenderFns } from "./resumenVenta.vue?vue&type=template&id=115370af&scoped=true"
import script from "./resumenVenta.vue?vue&type=script&lang=js"
export * from "./resumenVenta.vue?vue&type=script&lang=js"
import style0 from "./resumenVenta.vue?vue&type=style&index=0&id=115370af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115370af",
  null
  
)

export default component.exports